import { render, staticRenderFns } from "./certPhoto.vue?vue&type=template&id=ce60b0f2&scoped=true"
import script from "./certPhoto.vue?vue&type=script&lang=ts"
export * from "./certPhoto.vue?vue&type=script&lang=ts"
import style0 from "./certPhoto.vue?vue&type=style&index=0&id=ce60b0f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce60b0f2",
  null
  
)

export default component.exports